'use strict';

import {unflatten} from "flat";

export default class AdminController {
  /*@ngInject*/
  constructor(User, dialogs, Auth, Config, DTOptionsBuilder, IntegrationService, $uibModal) {
    // Use the User $resource to fetch all users
    this.dialogs = dialogs;
    this.isSuperAdmin = Auth.isSuperAdminSync();
    this.isAdmin = Auth.isAdminSync();
    this.roles = Config.getPlatformConfig().getUserRoles();
    this.Auth = Auth;
    this.User = User;
    this.IntegrationService = IntegrationService;
    this.$uibModal = $uibModal;

    this.configMS = Config.getPlatformConfig().getManagementSuiteIntegratonSettings();

    if (this.configMS && this.configMS.clientCode) {
      this.integrationAvailable = true;
    }

    const signUpConfig = Config.getModuleConfig(Config.Modules.SignUp);
    this.showAddUser = signUpConfig.getAdminAddUser();

    this.currentFilter = '';

    this.count = {
      local: 0,
      suiteuser: 0,
      suitewa: 0
    };

    this.dtOptions = DTOptionsBuilder.newOptions()
      .withOption('dom', 'lBfrtip')
      .withOption('buttons',[{
        extend: 'excel',
        title: 'User List'
      },{
        extend: 'csv',
        title: 'User List'
      },{
        title: 'User List',
        message: 'As of ' + moment().format("MMMM Do YYYY"),
        extend: 'pdf',
        orientation: 'landscape',
        pageSize: 'LETTER'
      },'print']);

    this.getData();
  }

  getData(useCurrentFilter) {
    this.User.query(data => {
      this.users = data;

      this.count.local = data.length;

      if (this.integrationAvailable) {

        this.IntegrationService.querySuiteLDAP({
          base: btoa("ou=users, o=conduu"),
          filter: btoa("(objectClass=conduuUser)")
        }, data => {

          if (data && data[0]) {

            this.users = this.users.concat(data.map(suiteUser => {
              this.count.suiteuser++;
              let json = JSON.parse(suiteUser.json);
              json.provider="Suite: User";
              return json;
            }))

          }

          this.IntegrationService.querySuiteLDAP({
            base: btoa("ou=webaccess, o=conduu"),
            filter: btoa("(cn="+this.configMS.clientCode+":*)")
          }, data => {

            if (data && data[0]) {

              let unflatten = require('flat').unflatten;

              this.users = this.users.concat(data.map(wa => {
                this.count.suitewa++;
                let unflatWa = unflatten(wa);

                let json = JSON.parse(wa.json);

                json.provider="Suite: Web Access";
                json.email = wa.email;
                json.role = Array.isArray(unflatWa.role) ? unflatWa.role : [unflatWa.role];
                json.isActive = unflatWa.isActive.length !== 0 && unflatWa.isActive[0] === true;
                json.isBlocked = unflatWa.isBlocked.length !== 0 && unflatWa.isBlocked[0] === true;

                return json;
              }))

            }

            useCurrentFilter ? this.setFilter(this.currentFilter) : this.setFilter();

          }, err => {
            console.log("Could not retrieve suite recipient lists from server.");
            useCurrentFilter ? this.setFilter(this.currentFilter) : this.setFilter();
          });

        }, err => {
          console.log("Could not retrieve suite recipient lists from server.");
          useCurrentFilter ? this.setFilter(this.currentFilter) : this.setFilter();
        });

      } else {
        useCurrentFilter ? this.setFilter(this.currentFilter) : this.setFilter();
      }
    });
  }

  openUserAddModal() {
    var that = this;
    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'userAdd',
      backdrop: 'static', // Prevents the modal to close, when clicking in the background
      resolve: {
        config: function() {
          return {}
        }
      }
    });

    modalInstance.result.then(
      function () {
        that.getData(true);
      },
      function () {
      }
    );
  }

  setFilter(filter) {

    switch (filter) {
      case 'local':
      case 'Suite: User':
      case 'Suite: Web Access':
        this.filteredUsers = this.users.filter(u => u.provider == filter);
        break;
      default:
        this.filteredUsers = this.users;
    }

    this.currentFilter = filter;
    this.ready = true;
  }

  patchUserRoles(user) {
    this.Auth.patchUserRoles(user);
  }

  delete(user) {

    var userStr = "<br/><br/><b>" + user.firstName + ' ' + user.lastName + "</b>";
    var dlg = this.dialogs.confirm("Delete user?", "Do you really want to delete this user?" + userStr+ "<br/><br/>This action can't be undone.");
    dlg.result.then(() => {
      /* Delete the user */
      user.$remove();
      this.users.splice(this.users.indexOf(user), 1);
      this.count.local--;
      this.setFilter(this.currentFilter);
    }, () => {
      // Cancel
    });

  }
}



// WEBPACK FOOTER //
// ./client/~ap/app/admin/user-list/admin.controller.js